/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: K
 * @LastEditTime: 2022-09-27 14:22:45
 */
import { Space, TableColumnType } from 'antd'
import React, { ReactElement } from 'react'
import { Tenant } from '../../../models/tenant'
import { ThemeData } from '../../../theme/ThemeContext'

export const columns = (
  onClick: (type: 'setting' | 'relieve' | 'herbs' | 'againBind', tenant: Tenant) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<Tenant>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构编号',
      key: 'id',
      align: 'center',
      width: '12rem',
      dataIndex: 'id',
    },
    {
      title: '机构名称',
      key: 'tenantName',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
    },
    {
      title: '合作平台',
      key: 'platformName',
      dataIndex: 'platformName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
    },

    {
      title: '代煎类别',
      key: 'decoctionType',
      align: 'center',
      dataIndex: 'decoctionType',
      width: '8rem',
    },
    {
      title: '加工方式',
      key: 'machiningType',
      dataIndex: 'machiningType',
      align: 'center',
      ellipsis: true,
      width: '8rem',
    },

    {
      title: '代煎绑定时间',
      key: 'bindingTime',
      align: 'center',
      dataIndex: 'bindingTime',
      width: '12rem',
    },
    {
      title: '签约状态',
      key: 'signedType',
      align: 'center',
      dataIndex: 'signedType',
      width: '8rem',
      render: (_, t) => (t.signedType === 1 ? '已签约' : '未签约'),
    },

    {
      title: '绑定状态',
      key: 'status',
      align: 'center',
      width: '10rem',
      render: (_, t) => (t.status === 1 ? '正常' : '已解绑'),
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '16em',
      render: function ActionBar(_, t): ReactElement {
        return t.status !== 1 ? (
          <a onClick={() => onClick('againBind', t)}>重新绑定</a>
        ) : (
          <Space>
            <a onClick={() => onClick('setting', t)}>代煎设置</a>
            <a onClick={() => onClick('herbs', t)}>商品目录 </a>
            <a onClick={() => onClick('relieve', t)} style={{ color: 'red' }}>
              解除绑定
            </a>
          </Space>
        )
      },
    },
  ]
}
